module.exports = __webpack_public_path__ + "img/asx_seat.2eeb682e.jpg";